import Logger from 'zen-logger';
export default new Logger({
  level: 'warn',
  bizName: 'renderer'
});